<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="xrx-alert-popup show fade-in"
  role="alertdialog"
  aria-labelledby="alert-title"
  tabindex="-1"
  style="margin-top: 8%">
  <div class="ap-content">
    @if (title) {
      <h3 id="alert-title" class="ap-title" [xdaTranslate]="title"></h3>
    }
    @if (body) {
      <div class="ap-primary" [xdaTranslate]="body"></div>
    }
    @if (additional) {
      <div class="ap-secondary" [xdaTranslate]="additional"></div>
    }
    <div class="ap-buttons">
      <div class="cb">
        <button
          type="button"
          class="xrx-btn btn-secondary-alert"
          (click)="activeModal.close()">
          <span class="btn-label" [xdaTranslate]="buttonText"></span>
        </button>
      </div>
      @if (dangerButtonText) {
        <div class="cb">
          <button
            type="button"
            class="xrx-btn btn-danger"
            (click)="this.activeModal.close('Delete')">
            <span class="btn-label" [xdaTranslate]="dangerButtonText"></span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
